var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.6 1.8c-.3.3-.5.8-.5 1.4v17.6c0 .6.2 1.1.5 1.4l10-10.2-10-10.2zm11.1 11.3 2.8 2.8-11.8 6.7c-.4.2-.8.2-1.1 0l10.1-9.5zm0-2.2L4.6 1.4c.3-.2.7-.2 1.1 0l11.8 6.7-2.8 2.8zm3.9 4.1-3.1-3 3.1-3.1 3.5 2c1 .6 1 1.6 0 2.1l-3.5 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.aac7c60b4bf0553400395fa9ad6fd8ac.svg";
export { ForwardRef as ReactComponent };